import React from 'react';
import './add_patient_mobile.css';
import { SYRIAN_GOVERNORATES } from './add_patient_step2';
export function AddPatientMobileStep1({ formData, errors, handleChange, onNext, isSubmitting, statusMessage }) {
  return (
    <div className="mobile-add-patient-container" dir="rtl">
      <div className="mobile-header">
        <h2>إضافة مريض جديد (الخطوة 1)</h2>
      </div>

      {/* عرض الأخطاء أو التحميل في الخطوة الأولى للموبايل */}
      {statusMessage && statusMessage.text && (
        <div className={`status-alert alert-${statusMessage.type}`}>
          {statusMessage.type === 'loading' && <i className="fa-solid fa-circle-notch fa-spin"></i>}
          {statusMessage.type === 'error' && <i className="fa-solid fa-triangle-exclamation"></i>}
          {statusMessage.type === 'success' && <i className="fa-solid fa-circle-check"></i>}
          <span>{statusMessage.text}</span>
        </div>
      )}
      
      <form className="mobile-form" onSubmit={onNext}>
        <div className="input-group">
          <label>الاسم الثلاثي</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} className={errors.name ? "input-error" : ""} disabled={isSubmitting}/>
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        <div className="input-group">
          <label>الرقم الوطني</label>
          <input type="tel" name="national_number" value={formData.national_number} onChange={handleChange} maxLength="11" disabled={isSubmitting}/>
          {errors.national_number && <span className="error-text">{errors.national_number}</span>}
        </div>

        <div className="input-group">
          <label>رقم الهاتف</label>
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} disabled={isSubmitting}/>
          {errors.phone && <span className="error-text">{errors.phone}</span>}
        </div>

        <div className="input-group">
          <label>تاريخ الميلاد</label>
          {/* في الموبايل، Input type=date يعمل بكفاءة عالية */}
          <input type="date" name="birth_date" value={formData.birth_date || ""} onChange={handleChange} disabled={isSubmitting}/>
          {errors.birth_date && <span className="error-text">{errors.birth_date}</span>}
        </div>

        <div className="input-group">
          <label>الجنس</label>
          <select name="gender" value={formData.gender} onChange={handleChange} disabled={isSubmitting}>
            <option value="">اختر الجنس</option>
            <option value="male">ذكر</option>
            <option value="female">أنثى</option>
          </select>
          {errors.gender && <span className="error-text">{errors.gender}</span>}
        </div>

        {/* الكلاس الموحد الجديد mobile-btn-primary */}
        <button type="submit" className={`mobile-btn-primary ${isSubmitting ? 'btn-disabled' : ''}`} disabled={isSubmitting}>
          {isSubmitting ? "جاري التحقق..." : "متابعة للخطوة 2"}
        </button>
      </form>
    </div>
  );
}

// ... (كود AddPatientMobileStep1 يبقى كما هو بلا تغيير) ...

export function AddPatientMobileStep2({ formData, handleChange, onSubmit, isSubmitting, statusMessage, openMapForAddress }) {
  return (
    <div className="mobile-add-patient-container" dir="rtl">
      <div className="mobile-header">
        <h2>بيانات إضافية (الخطوة 2)</h2>
      </div>

      {statusMessage.text && (
        <div className={`status-alert alert-${statusMessage.type}`}>
          {statusMessage.type === 'loading' && <i className="fa-solid fa-circle-notch fa-spin"></i>}
          {statusMessage.type === 'error' && <i className="fa-solid fa-triangle-exclamation"></i>}
          {statusMessage.type === 'success' && <i className="fa-solid fa-circle-check"></i>}
          <span>{statusMessage.text}</span>
        </div>
      )}
      
      <form className="mobile-form" onSubmit={onSubmit}>
        
        {/* 🔹 تحويل المدينة إلى قائمة منسدلة (Combo Box) للموبايل 🔹 */}
        <div className="input-group">
          <label>المحافظة</label>
          <select 
            name="city" 
            value={formData.city} 
            onChange={handleChange} 
            disabled={isSubmitting}
          >
            <option value="">اختر المحافظة...</option>
            {SYRIAN_GOVERNORATES.map(gov => (
               <option key={gov} value={gov}>{gov}</option>
            ))}
          </select>
        </div>

        <div className="input-group relative">
          <label>العنوان التفصيلي (السكن)</label>
          <div onClick={() => !isSubmitting && openMapForAddress()} className="relative cursor-pointer">
            <input 
              type="text" 
              name="address" 
              value={formData.address} 
              placeholder="اضغط لتحديد الموقع على الخريطة 📍" 
              readOnly 
              disabled={isSubmitting}
              className="cursor-pointer"
              style={{ backgroundColor: '#f0f6fa', cursor: 'pointer' }}
            />
            <i className="fa-solid fa-map-location-dot absolute left-4 top-1/2 transform -translate-y-1/2 text-[#0b4f6f] text-lg"></i>
          </div>
        </div>

        <div className="input-group">
          <label>زمرة الدم</label>
          <select name="blood_group" value={formData.blood_group} onChange={handleChange} disabled={isSubmitting}>
            <option value="">غير محدد</option>
            <option value="A+">A+</option>
            <option value="O+">O+</option>
            <option value="B+">B+</option>
            <option value="AB+">AB+</option>
          </select>
        </div>

        <button type="submit" className={`mobile-btn-primary ${isSubmitting ? 'btn-disabled' : ''}`} disabled={isSubmitting}>
          {isSubmitting ? "جاري التشفير والحفظ..." : "حفظ بيانات المريض"}
        </button>
      </form>
    </div>
  );
}